import React, { useEffect, useState } from 'react';
import Modal from '../components/Modal';

const PITLDiscountDisclaimer = ({ onClick }) => {
	return (
		<>
			Discount Applied. Excludes $40 non-refundable fee
			<i className="fa padding-x-xs fa-info-circle text-primary cursor-pointer" onClick={onClick}></i>
		</>
	);
};

const PITLRefundPolicyModal = ({ onClose }) => {
	const displayProps = {
		modalContent: { style: { textAlign: 'initial' } },
		modalBody: { style: { paddingTop: '0', maxHeight: '80vh', overflowY: 'auto' } }
	};
	return (
		<Modal modalLarge={true} displayProps={displayProps} modalHidden={onClose}>
			<PITLRefundPolicy />
		</Modal>
	);
};

/**
 * Fetches the refund policy HTML from the website and displays it.
 * An error message with a link to the Genova Connect refund policy is displayed if the fetch fails.
 */
const PITLRefundPolicy = () => {
	const [loading, setLoading] = useState(true);
	const [policyHtml, setPolicyHtml] = useState(null);

	useEffect(() => {
		const abortController = new AbortController();

		setLoading(true);
		window
			._fetch(`${process.env.REACT_APP_GDX_WEB_URL}/html/connect/refund-policy/index.html`, {
				signal: abortController.signal,
				mode: 'cors',
				credentials: 'include',
				method: 'GET',
				timeout: 1000,
				headers: {
					Accept: 'text/plain',
					'Content-Type': 'text/plain'
				}
			})
			.then((response) => {
				if (response.ok) {
					return response.text();
				}
				return Promise.reject();
			})
			.then((html) => {
				setPolicyHtml(html);
			})
			.catch((e) => {})
			.finally(() => setLoading(false));

		return () => abortController.abort();
	}, []);

	if (loading) {
		return (
			<div>
				<h2>Refund and Replacement Policy</h2>
				<div className="text-center pb-10">
					<i
						className="fa fa-spinner fa-spin fa-fw loading-iconx"
						aria-hidden="true"
						style={{
							fontSize: '75px',
							lineHeight: '80px',
							width: '80px'
						}}
					></i>
				</div>
			</div>
		);
	}

	if (!policyHtml) {
		return (
			<div className="text-center">
				<h1>Ooops! Page Not Found - 404</h1>
				<p>
					View the Refund and Replacement Policy at{' '}
					<a href="https://connect.gdx.net/refund-policy" target="_blank" rel="noopener noreferrer">
						https://connect.gdx.net/refund-policy
						<span className="fa fa-external-link ml-5"></span>
					</a>
				</p>
			</div>
		);
	}

	return <div dangerouslySetInnerHTML={{ __html: policyHtml }}></div>;
};

export { PITLDiscountDisclaimer, PITLRefundPolicyModal };
